import { render, staticRenderFns } from "./PortalNotAvailable.vue?vue&type=template&id=90d2f1ea&scoped=true&"
import script from "./PortalNotAvailable.vue?vue&type=script&setup=true&lang=js&"
export * from "./PortalNotAvailable.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PortalNotAvailable.vue?vue&type=style&index=0&id=90d2f1ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d2f1ea",
  null
  
)

export default component.exports